var map = {
	"./arg.svg": 2346,
	"./aus.svg": 2347,
	"./bel.svg": 2348,
	"./bra.svg": 2349,
	"./can.svg": 2350,
	"./cmr.svg": 2351,
	"./crc.svg": 2352,
	"./cro.svg": 2353,
	"./den.svg": 2354,
	"./ecu.svg": 2355,
	"./eng.svg": 2356,
	"./esp.svg": 2357,
	"./fra.svg": 2358,
	"./ger.svg": 2359,
	"./gha.svg": 2360,
	"./irn.svg": 2361,
	"./jpn.svg": 2362,
	"./kor.svg": 2363,
	"./ksa.svg": 2364,
	"./mar.svg": 2365,
	"./mex.svg": 2366,
	"./ned.svg": 2367,
	"./pol.svg": 2368,
	"./por.svg": 2369,
	"./qat.svg": 2370,
	"./sen.svg": 2371,
	"./srb.svg": 2372,
	"./sui.svg": 2373,
	"./tun.svg": 2374,
	"./uru.svg": 2375,
	"./usa.svg": 2376,
	"./wal.svg": 2377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;